import {XmlTagInfo} from "../../xmlTagProvider";
import Cell from "../../form/cell";
import {Form} from "../../form/form";
import {Questionary} from "../../questionary";
import {DropTargetView} from "../../../ui/items/dragdrop/dropTargetView";
import {DragItem} from "./dragItem";

export class DropTargetItem extends DragItem {

    static fromXml(config: XmlTagInfo) {
        return new DropTargetItem(config);
    }

    constructor(config: XmlTagInfo) {
        super(config);
    }

    init(questionary: Questionary, form: Form, cell: Cell) {
        super.init(questionary, form, cell);
        this.view = new DropTargetView({cellItem: this});
        this.dragGroup.getAcceptSourceGroups().forEach(g => this.registerEvents(g));

        // Load
        if( this.getVariable() > 0 ) {
            this.dragGroup.getDragValuesTransitive()
                .filter(dv => dv.value() === this.getVariable() )
                .forEach(dv => dv.set(this));
        }
    }

    resourcesToPreload() {
        return this.getSimpleContentResources(this.childrenTags);
    }

    set(value: any) {
        this.setVariable(value);
        this.updateUnknowns();
        this.form.reValidate();
    }

}